import { TRIGGER_LOADING } from '../constants/ActionTypes';
import _ from 'lodash';
import { setLoadingApi } from 'utils';
import { isFulfilled, isRejectedWithValue, isRejected, isPending } from '@reduxjs/toolkit';

export const setLoading = status => {
	return {
		type: TRIGGER_LOADING,
		payload: { status }
	};
};

export const loading = (state = false, action) => {
	switch (action.type) {
		case TRIGGER_LOADING:
			return action.payload.status;
		default:
			return state;
	}
};

export const loadingMiddleware = storeAPI => next => action => {
	if (isPending(action)) {
		let api = action?.meta?.arg;
		if (api?.endpointName) {
			_.forEach(setLoadingApi(), endpoint => {
				if (endpoint.endpointName === api?.endpointName) {
					storeAPI.dispatch(setLoading(true));
					// end foreach early after finding the requested endpoint
					return false;
				}
			});
		}
	}

	if (isRejected(action)) {
		let api = action?.meta?.arg;
		if (api?.endpointName) {
			_.forEach(setLoadingApi(), endpoint => {
				if (endpoint.endpointName === api?.endpointName) {
					storeAPI.dispatch(setLoading(false));

					// end foreach early after finding the requested endpoint
					return false;
				}
			});
		}
	}
	if (isFulfilled(action)) {
		let api = action?.meta?.arg;

		if (api?.endpointName) {
			_.forEach(setLoadingApi(), endpoint => {
				if (endpoint.endpointName == api?.endpointName) {
					storeAPI.dispatch(setLoading(false));

					// end foreach early after finding the requested endpoint
					return false;
				}
			});
		}
	} else if (isRejectedWithValue(action)) {
		let api = action?.meta?.arg;
		if (api?.endpointName) {
			_.forEach(setLoadingApi(), endpoint => {
				if (endpoint.endpointName === api?.endpointName) {
					storeAPI.dispatch(setLoading(false));
					return false;
				}
			});
		}
	}

	return next(action);
};
